import { Inject, Injectable, DOCUMENT } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class JsonLdService {
  private readonly scriptId = 'ld';

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  set(schema: unknown): void {
    if (!this.document?.head) return;

    let scriptEl = this.document.getElementById(this.scriptId) as HTMLScriptElement | null;
    if (!scriptEl) {
      scriptEl = this.document.createElement('script');
      scriptEl.id = this.scriptId;
      scriptEl.type = 'application/ld+json';
      this.document.head.appendChild(scriptEl);
    }

    scriptEl.textContent = JSON.stringify(schema);
  }

  setGraph(nodes: unknown[]): void {
    this.set({
      '@context': 'https://schema.org',
      '@graph': nodes,
    });
  }

  clear(): void {
    const el = this.document?.getElementById?.(this.scriptId);
    if (el?.parentNode) el.parentNode.removeChild(el);
  }
}
